import { Helmet } from "react-helmet-async";
import { useEffect, useState } from "react";
// @mui
import {
  Card,
  Table,
  Stack,
  Paper,
  Button,
  Popover,
  TableRow,
  MenuItem,
  TableBody,
  TableCell,
  Container,
  Typography,
  IconButton,
  TableContainer,
  TableHead,
  CircularProgress,
  Box,
  Alert,
  Dialog,
  DialogTitle,
  DialogContent,
  DialogContentText,
  DialogActions,
} from "@mui/material";
// components

import Iconify from "../components/iconify";
import Scrollbar from "../components/scrollbar";

import { useNavigate, useSearchParams } from "react-router-dom";
import axios from "axios";
// ----------------------------------------------------------------------

export default function GameUsersPage() {
  const navigate = useNavigate();
  const [loading, setLoading] = useState(false);
  const [open, setOpen] = useState(null);
  const [openId, setOpenId] = useState(null);
  const [rows, setRows] = useState(null);
  const [game, setGame] = useState(null);
  const [searchParams, setSearchParams] = useSearchParams();
  const [errorMessage, setErrorMessage] = useState(null);

  useEffect(() => {
    if (searchParams.has("game_id")) {
      let gameId = searchParams.get("game_id");
      axios
        .get(`${process.env.REACT_APP_API_BASE_URL}/admin/game/${gameId}/users`)
        .then(function (response) {
          setRows(response.data.users);
        });
      axios
        .get(`${process.env.REACT_APP_API_BASE_URL}/admin/games/${gameId}`)
        .then(function (response) {
          setGame(response.data.game);
        });
    } else {
      navigate("/404");
    }
  }, [setSearchParams, searchParams, navigate]);

  const handleGenerateGameCards = () => {
    setLoading(true);

    axios
      .post(
        `${process.env.REACT_APP_API_BASE_URL}/admin/game/${game.gameId}/generate-cards`
      )
      .then(function (response) {
        window.location.reload(false);
      })
      .catch(function (error) {
        setErrorMessage(error.response.data.error);
        setLoading(false);
      });
  };
  const handleOpenMenu = (event) => {
    setOpen(event.currentTarget);
    setOpenId(event.currentTarget.id);
  };

  const handleCloseMenu = () => {
    setOpen(null);
    setOpenId(null);
  };
  return (
    <>
      <Helmet>
        <title> Bingo Game Questions </title>
      </Helmet>

      <Container>
        <Stack
          direction="row"
          alignItems="center"
          justifyContent="space-between"
          mb={5}
        >
          <Typography variant="h4" gutterBottom>
            Game Users
          </Typography>
          {true && (
            <Button
              variant="contained"
              startIcon={<Iconify icon="eva:flip-2-outline" />}
              onClick={() => handleGenerateGameCards()}
              disabled={loading}
            >
              Generate Cards
            </Button>
          )}
        </Stack>
        {game !== null ? (
          <>
            <Alert sx={{ marginBottom: 2 }} severity="info">
              {`Game Card questions settings: Easy Level - ${game.easyQuestionsCount}, Medium Level - ${game.mediumQuestionsCount}, Hard Level - ${game.hardQuestionsCount}, Team Questions - ${game.teamQuestionsCount}, Player Questions - ${game.playerQuestionsCount}`}
            </Alert>
            <Alert sx={{ marginBottom: 2 }} severity="info">
              {`Game sign ups with cards: ${game.usersWithCardsCount} / ${game.allUsersCount}`}
            </Alert>
            <Alert sx={{ marginBottom: 2 }} severity="info">
              {`Generated cards: ${game.cardsCount}`}
            </Alert>
          </>
        ) : null}

        <Card>
          {rows === null || loading ? (
            <Box
              sx={{ display: "flex", justifyContent: "center" }}
              style={{ padding: 20 }}
            >
              <CircularProgress />
            </Box>
          ) : (
            <Scrollbar>
              <TableContainer component={Paper}>
                <Table sx={{ minWidth: 650 }} aria-label="simple table">
                  <TableHead>
                    <TableRow>
                      <TableCell>User ID</TableCell>
                      <TableCell>Username</TableCell>
                      <TableCell>Has Card</TableCell>
                      <TableCell align="right"></TableCell>
                    </TableRow>
                  </TableHead>
                  <TableBody>
                    {rows.map((row, index) => (
                      <TableRow
                        key={index}
                        sx={{
                          "&:last-child td, &:last-child th": { border: 0 },
                        }}
                      >
                        <TableCell component="th" scope="row">
                          {row.userId}
                        </TableCell>
                        <TableCell component="th" scope="row">
                          {row.username}
                        </TableCell>
                        <TableCell component="th" scope="row">
                          {row.hasCard ? (
                            <Iconify
                              icon={"eva:checkmark-circle-2-outline"}
                              sx={{ color: "green" }}
                            />
                          ) : (
                            <Iconify
                              icon={"eva:close-circle-outline"}
                              sx={{ color: "red" }}
                            />
                          )}
                        </TableCell>

                        <TableCell align="right">
                          <IconButton
                            size="large"
                            color="inherit"
                            onClick={handleOpenMenu}
                            id={row.userId}
                          >
                            <Iconify icon={"eva:more-vertical-fill"} />
                          </IconButton>
                        </TableCell>
                      </TableRow>
                    ))}
                  </TableBody>
                </Table>
              </TableContainer>
            </Scrollbar>
          )}
        </Card>
      </Container>

      <Dialog
        open={errorMessage !== null}
        onClose={() => setErrorMessage(null)}
        aria-labelledby="alert-dialog-title"
        aria-describedby="alert-dialog-description"
      >
        <DialogTitle id="alert-dialog-title">ERROR</DialogTitle>
        <DialogContent>
          <DialogContentText id="alert-dialog-description">
            {errorMessage}
          </DialogContentText>
        </DialogContent>
        <DialogActions>
          <Button onClick={() => setErrorMessage(null)}>OK</Button>
        </DialogActions>
      </Dialog>
      <Popover
        open={Boolean(open)}
        anchorEl={open}
        onClose={handleCloseMenu}
        anchorOrigin={{ vertical: "top", horizontal: "left" }}
        transformOrigin={{ vertical: "top", horizontal: "right" }}
        PaperProps={{
          sx: {
            p: 1,
            width: 140,
            "& .MuiMenuItem-root": {
              px: 1,
              typography: "body2",
              borderRadius: 0.75,
            },
          },
        }}
      >
        <MenuItem
          onClick={() =>
            navigate(
              `/dashboard/game/user-card?game_id=${game.gameId}&user_id=${openId}`
            )
          }
        >
          <Iconify icon={"eva:keypad-outline"} sx={{ mr: 2 }} />
          Game Card
        </MenuItem>
      </Popover>
    </>
  );
}
